import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';

const FilterClearButton = (props) => {
  return (
    <Button
      style={{
        color: '#368007',
        border: 'none',
        outline: 'none',
        hover: 'none',
        boxShadow: 'none',
        backgroundColor: '#FFFFFF',
        display: 'flex',
      }}
      onClick={() => {
        props.clearFilter(null);
      }}
    >
      CLEAR ALL
    </Button>
  );
};

export default FilterClearButton;
